import { Injectable } from '@angular/core';
import { OrderStatusModel } from '@libs/shared/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({ providedIn: 'root' })
export class OrderStatusRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getOrderStatus(orderId: string): Observable<OrderStatusModel> {
    return this.connector.connect<OrderStatusModel>(
      'service',
      'orderStatus',
      {
        pathParams: {
          orderId,
        },
      },
    );
  }
}
